const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.CLIENT_DIET_DAYS)

export const apiOrderDays = {
	// eslint-disable-next-line max-params -- recursive pagination, accumulatedData is an internal accumulator
	fetchOrderDays: async (
		clientID: number | undefined,
		dayFrom: Date | undefined,
		dayTo: Date | undefined,
		status?: EDietStatus | undefined,
		clientDietID?: number | undefined,
		page: number = 1,
		perPage: number = 50,
		accumulatedData: IOrderDay[] = [],
	): Promise<{ data: IOrderDayModel[]; meta: IApiMetaModel }> => {
		const dateFrom = dayFrom ? dateToFilterFormat(dayFrom) : undefined
		const dateTo = dayTo ? dateToFilterFormat(dayTo) : undefined

		const { data, meta } = await apiCommon<IOrderDay[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				{ page, perPage },
				{
					date_from: dateFrom,
					date_to: dateTo,
					'clientDiet.client_id': clientID,
					'clientDiet.status': status,
					client_diet_id: clientDietID,
				},
			),
		})
		// arbitrary pagination - fetch all items for calendar
		const newAccumulatedData = accumulatedData.concat(data)

		if (meta && (meta.currentPage ?? 0) < (meta.lastPage ?? 0)) {
			return apiOrderDays.fetchOrderDays(
				clientID,
				dayFrom,
				dayTo,
				status,
				clientDietID,
				page + 1,
				perPage,
				newAccumulatedData,
			)
		} else {
			return { data: newAccumulatedData.map(OrderDay), meta }
		}
	},

	fetchOrderDay: async (orderDayID: number) => {
		const { data } = await apiCommon<IOrderDay>(`${groupPrefix}/${orderDayID}`, { method: 'GET' })
		return OrderDay(data)
	},

	calculateOrderDayMealChange: async (orderDayID: number, mealSlots: { uuid: string; variant_id: number }[]) => {
		const { data } = await apiCommon<IOrderDayChange>(`${groupPrefix}/${orderDayID}/select-meals/calculate`, {
			method: 'POST',
			body: { client_meal_slots: mealSlots },
		})
		return OrderDayChange(data)
	},

	addOrderDayMeal: async (
		orderDayID: number,
		mealSlots: { uuid: string; variant_id: number }[],
		obj: IOrderDayChangeModel,
	) => {
		const { data } = await apiCommon<IOrderDay>(`${groupPrefix}/${orderDayID}/select-meals`, {
			method: 'POST',
			body: { ...orderDayChangeToJSON(obj), client_meal_slots: mealSlots },
		})
		return { data: OrderDay(data) }
	},

	deleteOrderDayMeal: async (orderDayID: number, mealSlotsUUIDs: string[]) => {
		const { data } = await apiCommon<IOrderDay>(`${groupPrefix}/${orderDayID}/cancel-meals`, {
			method: 'POST',
			body: { client_meal_slot_uuid: mealSlotsUUIDs },
		})
		return { data: OrderDay(data) }
	},

	deleteOrderDayAddon: async (orderDayID: number, dayAddonIDs: number[]) => {
		const { data } = await apiCommon<IOrderDay>(`${groupPrefix}/${orderDayID}/cancel-meals`, {
			method: 'POST',
			body: { addon_client_diet_day_id: dayAddonIDs },
		})
		return { data: OrderDay(data) }
	},
}
